import t from '@zenlayer/zen-intl18';
export var industrys = [{
  value: 'Aerospace',
  label: t('T0mYwZankkxX')
}, {
  value: 'AI & Software & SaaS & Internet',
  label: t('YKJzNzBQt969')
}, {
  value: 'Automotive',
  label: t('0igTwuChvdiq')
}, {
  value: 'Blockchain/Crypto',
  label: t('RdFE1fmv2QuL')
}, {
  value: 'Computers & Electronics',
  label: t('AZJ4fpeCmEjM')
}, {
  value: 'Cybersecurity & Network',
  label: t('lsSVSCIKKHmN')
}, {
  value: 'Data Center & Telecommunications',
  label: t('9PdIPWNxjfWM')
}, {
  value: 'Education',
  label: t('EiAw2SKXhIM6')
}, {
  value: 'Finance & Fintech',
  label: t('4OCjvwXngW6h')
}, {
  value: 'Gaming',
  label: t('G6MEV6BVe2AC')
}, {
  value: 'Government',
  label: t('mR4dHcG2ORcA')
}, {
  value: 'Hospitality & Travel',
  label: t('nVHsy7XoOgxu')
}, {
  value: 'IT / Professional Services',
  label: t('640vBUecAflQ')
}, {
  value: 'Life Science & Healthcare',
  label: t('GLF7mJoJYIva')
}, {
  value: 'Manufacturing',
  label: t('EXXHxMMGFxaL')
}, {
  value: 'Marketing & Advertising & Media & Entertainmeng',
  label: t('7sIaf3ufrbP7')
}, {
  value: 'Non-Profit Organization',
  label: t('UOLVQ1LahykX')
}, {
  value: 'Oil & Gas & Power & Utilities',
  label: t('8UFgVMKT5NGx')
}, {
  value: 'Retail & Consumer Goods',
  label: t('meEKnAWSHAdT')
}, {
  value: 'Transportation & Logistics',
  label: t('UnkpPNxsev5K')
}, {
  value: 'Other',
  label: t('fXPIPOWFxDRQ')
}];